const CHAT_NOTIFIER_LOAD_SUCCESS = 'CHAT_NOTIFIER_LOAD_SUCCESS';

const CHAT_NOTIFIER_LOAD_URL = '/messenger-api/notification/index';

const REDUCER_CHAT_NOTIFIER_NAME = 'reducerChatNotifier';

export {
  CHAT_NOTIFIER_LOAD_SUCCESS,

  CHAT_NOTIFIER_LOAD_URL,

  REDUCER_CHAT_NOTIFIER_NAME,
};
